import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription, timer, switchMap, tap,debounceTime, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ToastService  {
  toasts$:BehaviorSubject< any[]> = new BehaviorSubject([]);
  private toasts:any[]=[];
  constructor() { 
  }
  show(header: string, body: string, options: any = {}) {
    var toast={ header, body, ...options };
    console.log('Making toast', toast);
    this.toasts.push(toast);
    this.toasts$.next(this.toasts);
  }
  remove(toast) {
    this.toasts = this.toasts.filter(t => t != toast);
  }
  clear() {
    this.toasts.length=0;
  }
}
